<template>
  <div>
    <breadcrumb-bar :crumbs="[]">
      <ul class="page-breadcrumb" style="padding-left: 0">
        <li>
          <router-link :to="{ name: 'Reports Index', params: { reset: true }}"><span class="gold">Reports</span></router-link>
          <i class="fa fa-angle-right"></i></li>
        <li>
          <router-link :to="{ name: 'Top 5 Reports List'}">Top 5 Reports</router-link>
        </li>
      </ul>
    </breadcrumb-bar>

    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase">Top 5 Reports</span>
                </div>
              </div>
              <div class="portlet-body">
                <div class="form-body" :class="{loading: loading.list}">
                  <vue-spinner v-if="loading.list"></vue-spinner>
                  <div class="vgt-responsive">
                    <table class="vgt-table bordered">
                      <thead>
                      <tr>
                        <th v-for="col in columns" :class="{'cell-actions' : col.field === 'action', 'sorting' : col.field !== 'action'} ">
                          <span @click="sort(col.field)">{{ col.label }}</span>
                        </th>
                        <th rowspan="2">Top 5<br/>Reports</th>
                      </tr>
                      <tr>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Name" class="vgt-input" @change="filter('name', $event)"></div>
                        </th>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Description" class="vgt-input" @change="filter('description', $event)"></div>
                        </th>
                        <th class="filter-th"></th>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Created By" class="vgt-input" @change="filter('user', $event)"></div>
                        </th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr class="folder">
                        <td colspan="8"><router-link :to="{ name: 'Reports Index', params: { reset: true }}" tag="a"><i class="fa fa-level-up dark"></i> ... </router-link></td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr v-for="row in rows" v-if="reports.length" class="item">
                        <td>
                          <router-link :to="{ name: 'Reports Preview', params: { reportid: row.id } }" tag="a">{{ row.name }}</router-link>
                        </td>
                        <td>{{row.description}}</td>
                        <td class="vgt-text-nowrap">{{ row.mode == 2 ? 'Multiple Organizations' : 'Single Organization' }}</td>
                        <td class="vgt-text-nowrap">{{row.user}}</td>
                        <td>{{row.created_date.date | formatDate}}</td>
                        <td>
                          <template v-if="row.modified_date !== null">{{row.modified_date.date | formatDate}}</template>
                        </td>
                        <td>{{ (row.status == 1 ) ? 'Published' : 'Unpublished' }}</td>
                        <td class="cell-action">
                          <div class="last-dropdown">
                            <div class="btn-group">
                              <button class="btn btn-xs green dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"> Actions
                                <i class="fa fa-angle-down"></i>
                              </button>
                              <ul class="dropdown-menu" role="menu">
                                <li v-if="user.access > 3">
                                  <router-link :to="{ name: 'Reports Edit', params: { reportid: row.id } }" tag="a">
                                    <i class="fa fa-pencil-square-o"></i> Edit
                                  </router-link>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="changeStatusAction(row.id)">
                                    <i class="fa fa-eye"></i> Publish / Draft </a>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showDuplicateModal(row.id)">
                                    <i class="fa fa-files-o"></i> Duplicate </a>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showMoveToFolderModal('report', row.id)">
                                    <i class="fa fa-arrows"></i> Move </a>
                                </li>
                                <li>
                                  <a @click.prevent="exportReport(row.id, row.count)">
                                    <i class="fa fa-file-o"></i> Export
                                  </a>
                                </li>
                                <li class="divider" v-if="user.access > 3"></li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showDeleteReportModal(row.id)">
                                    <i class="fa fa-trash"></i> Delete
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                        <td>
                          <label class="mt-checkbox mt-checkbox-outline">
                            <input type="checkbox" :value="row.id" @change.prevent="selectTopReport(row.id)" :checked="topReportsIds.includes(row.id)" :disabled="topReportsIds.length >= 5 && !topReportsIds.includes(row.id)"/>
                            <span></span>
                          </label>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <button class="save-top-reports btn green pull-right" @click="saveTopReports">Save Top 5 Reports</button>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="duplicate-report-modal" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
              <h4 class="modal-title">Duplicate Report</h4></div>
            <div class="modal-body">
              <form data-vv-scope="d-report">
                <div class="form-group" :class="{ 'has-error': errors.has('d-report.name') }">
                  <label for="formname">Report Name</label>
                  <input id="formname" class="form-control" name="name" type="text" v-validate="'required'" v-model="name">
                  <span v-show="errors.has('d-report.name')" class="help-block">{{ errors.first('d-report.name') }}</span>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.has('d-report.description') }">
                  <label for="formdesc">Report Description</label>
                  <textarea id="formdesc" class="form-control" name="description" type="text" v-validate="'required'" v-model="description"></textarea>
                  <span v-show="errors.has('d-report.description')" class="help-block">{{ errors.first('d-report.description') }}</span>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button class="btn green mt-ladda-btn ladda-button duplicate-report-modal-btn" @click.prevent="submitDuplicate" data-style="expand-left">
                <span class="ladda-label">Duplicate Report</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="delete-report-modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
              <h4 class="modal-title">DELETE REPORT</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <p>Are you sure you would like to delete this Report?</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn green mt-ladda-btn ladda-button remove-participant-control" data-dismiss="modal" data-style="expand-left" @click.prevent="deleteReportAction(currentModal)">
                <span class="ladda-label">Yes</span>
              </button>
              <button class="btn default" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="move-to-folder-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">MOVE TO FOLDER</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <vue-select
                v-model="moveToFolderId"
                :options="accountFolders"
                label="name"
                value="id"
                :multiple=false
                placeholder="Select folder"
              >
                <template slot="option" slot-scope="option">
                  <template v-if="option.lvl > 1" v-for="idx in option.lvl">&nbsp;&nbsp;</template>
                  {{ option.name }}
                </template>
              </vue-select>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green mt-ladda-btn ladda-button remove-participant-control" data-dismiss="modal" data-style="expand-left"
                    @click.prevent="moveToFolderAction({'itemType' : currentModal.type, 'itemId' : currentModal.id, 'folderId' : moveToFolderId.id})">
              <span class="ladda-label">OK</span>
            </button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <export-modal v-if="showExportModal"
                  :report-id="exportReportId"
                  :result-total-rows="exportTotalRows"
                  v-on:display="showExportModal = $event"
    ></export-modal>

    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from 'vuex';
  import ExportModal from "./ExportModal";
  import vSelect from 'vue-select'

  export default {
    data() {
      return {
        name: '',
        description: '',
        currentModal: '',
        columns: [
          {label: 'Name', field: 'name'},
          {label: 'Description', field: 'description'},
          {label: 'Report Type', field: 'mode'},
          {label: 'Created By', field: 'user'},
          {label: 'Created On', field: 'created_date.date'},
          {label: 'Modified On', field: 'modified_date.date'},
          {label: 'Status', field: 'status'},
          {label: 'Action', field: 'action'},
        ],
        moveToFolderId: 0,
        foldersList: [],
        reportsList: [],
        sortBy: '',
        sortDir: 'asc',
        filterFields: [],
        topReportsIds: [],
        exportReportId: null,
        exportTotalRows: 0,
        showExportModal: false
      }
    },
    inject: {
      $validator: '$validator'
    },
    components: {
      ExportModal,
      'breadcrumb-bar': Breadcrumbs,
      'vue-spinner': Spinner,
      'vue-select': vSelect,
    },
    mounted() {
      this.getTopReportsAction();
      this.bindEvents();
    },
    computed: {
      ...mapGetters({
        reports: 'getTopReports',
        user: 'getUser',
        accountFolders: 'getAccountFolders',
        reportsCount: 'getReportsCount',
        topReportsIdsServer: 'getTopReportsIds',
        loading: 'getReportsLoading'
      }),
      rows() {
        let items = this.reports;

        if (this.filterFields.length) {
          _.forEach(this.filterFields, function (filter) {
            items = _.filter(items, function (item) {
              return item[filter.field].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
            })
          });
        }

        if (this.sortBy !== '') {
          if (this.sortBy.includes('.date')) {
            let sortBy = this.sortBy.slice(0, -5);
            items = _.orderBy(items, function (item) {
              return item[sortBy] !== null ? item[sortBy].date : new Date(-8640000000000000).toISOString();
            }, [this.sortDir]);
          } else {
            items = _.orderBy(items, [sort => sort[this.sortBy].toString().toLowerCase()], [this.sortDir]);
          }
        }

        return items;
      },
    },
    methods: {
      ...mapActions({
        getReportsAction: 'GET_REPORTS_LIST_ACTION',
        getTopReportsAction: 'GET_TOP_REPORTS_LIST_ACTION',
        deleteReportAction: 'DELETE_REPORT_ACTION',
        changeStatusAction: 'CHANGE_STATUS_REPORT_ACTION',
        duplicateReportAction: 'DUPLICATE_REPORT_ACTION',
        downloadReport: 'GENERATED_REPORT_ACTION',
        getAccountFoldersAction: 'GET_ACCOUNT_FOLDERS_ACTION',
        moveToFolderAction: 'MOVE_TO_FOLDER_ACTION',
        saveTopReportsAction: 'SAVE_TOP_REPORTS_ACTION',
      }),
      bindEvents() {
        let self = this;
        let modal = $('#duplicate-report-modal');

        modal.on('hidden.bs.modal', function () {
          self.clearDuplicateReportModal();
        }).on('show.bs.modal', function () {
          self.clearDuplicateReportModal();
        });
        let addFolderModal = $('#add-folder-modal');

        addFolderModal.on('hidden.bs.modal', () => {
          self.addFolderName = '';
          self.errors.clear('add-folder');
        }).on('show.bs.modal', () => {
          self.addFolderName = '';
          self.errors.clear('add-folder');
        });
      },

      showDuplicateModal(id) {
        this.currentModal = id;
        $('#duplicate-report-modal').modal('show');
      },
      showDeleteReportModal(id) {
        this.currentModal = id;
        $('#delete-report-modal').modal('show');
      },
      clearDuplicateReportModal() {
        this.name = '';
        this.description = '';
        this.errors.clear('d-report');
      },
      submitDuplicate() {
        this.$validator.validateAll('d-report').then((result) => {
          if (result) {
            const context = Ladda.create(document.querySelector('.duplicate-report-modal-btn'));
            this.duplicateReportAction({id: this.currentModal, name: this.name, description: this.description, context});
            $('#duplicate-report-modal').modal('hide');
          }
        });
      },
      downloadReportType(id, type) {
        this.downloadReport({id: id, from: '', to: '', timezone: this.user.time_zone, token: localStorage.getItem('id_token'), format: type})
      },
      showMoveToFolderModal(itemType, itemId) {
        this.currentModal = {
          type: itemType,
          id: itemId,
        };
        this.getAccountFoldersAction();
        $('#move-to-folder-modal').modal('show');
      },
      sort(field) {
        if (field === 'action') {
          return;
        }
        if (this.sortBy === field && this.sortDir === 'asc') {
          this.sortDir = 'desc';
          return;
        }
        if (this.sortBy === field && this.sortDir === 'desc') {
          this.sortDir = 'asc';
          return;
        }

        this.sortDir = 'asc';
        this.sortBy = field;
      },
      filter(field, event) {
        this.filterFields = _.filter(this.filterFields, function (item) {
          return item.field != field;
        });
        if (event.target.value === '') {
          return
        }
        this.filterFields.push({field: field, value: event.target.value});
      },
      selectTopReport(reportId) {
        let maxIds = this.topReportsIds.length >= 5;
        let idx = this.topReportsIds.indexOf(reportId);

        if (idx !== -1) {
          this.topReportsIds.splice(idx, 1);
        }

        if (idx === -1 && !maxIds) {
          this.topReportsIds.push(reportId)
        }
      },
      saveTopReports() {
        this.saveTopReportsAction({reportsIds: this.topReportsIds});
        this.getTopReportsAction();
      },
      exportReport(reportId, rowsCount) {
        this.exportReportId = reportId;
        this.exportTotalRows = rowsCount;
        this.showExportModal = true;
      }
    },
    watch: {
      topReportsIdsServer: function () {
        this.topReportsIds = this.topReportsIdsServer;
      }
    }
  }
</script>

<style scoped>
  .gold {
    color: #d09f23;
  }

  .last-dropdown {
    width: auto;
  }

  .vgt-table {
    margin-top: 1em;
  }

  .dropdown-menu {
    min-width: initial;
  }

  .vgt-table tbody + tbody {
    display: table-row-group;
  }

  .dark {
    color: #606266;
  }

  .form-body {
    position: relative;
  }

  .form-body.loading .vgt-responsive {
    opacity: 0.5;
  }

  .form-body .spinner {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
  }

  .save-top-reports {
    margin-top: 1em;
    margin-left: 3px;
    color: #333333;
  }

  .cell-action {
    overflow: visible;
  }

  .vgt-responsive {
    overflow: visible;
  }
  
  @media (max-width: 767px) {
    .vgt-table-responsive .dropdown-menu {
      position: static !important;
    }

    .dropdown-backdrop {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// ReportsTop5List.vue?c7e9ebca